export enum MatchStage {
	"신청대기" = 26,
	"신청완료" = 1,
	"상담요청" = 2,
	"상담대기" = 3,
	"구체화중" = 4,
	"구체화완료" = 5,
	"전문가서칭" = 6,
	"요청서검토" = 7,
	"프로필검토" = 8,
	"인터뷰세팅" = 9,
	"인터뷰대기" = 10,
	"제안서작성" = 11,
	"제안서검토" = 12,
	"계약입금안내" = 13,
	"신청홀딩" = 14,
	"온보딩진행" = 15,
	"리텐션관리" = 16,
	"서비스종료" = 17,
	"서비스이탈" = 18,
}

export enum ExpertStage {
	"서류심사" = 19,
	"역량평가대기" = 20,
	"역량평가심사" = 21,
	"심층면접대기" = 22,
	"심층면접심사" = 23,
	"계약대기" = 24,
	"최종합격" = 25,
}
